import React from 'react';

const Card = ({ image, date, title, description }) => {
  return (
    <div className="swiper-slide">
      <div
        style={{
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          padding: '20px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="row gy-4 align-items-center justify-content-between">
          <div className="col-12">
            <div style={{ textAlign: 'center', marginBottom: '15px' }}>
              <img
                src={image}
                style={{ maxWidth: '100%', borderRadius: '8px' }}
                alt="img"
              />
            </div>
          </div>
          <div className="col-12">
            <div style={{ textAlign: 'center' }}>
              <p
                style={{
                  color: '#6c757d',
                  fontSize: '14px',
                  marginBottom: '10px',
                }}
              >
                <span style={{ marginRight: '10px', verticalAlign: 'middle' }}>
                  <svg width={16} height={17}>
                    <use xlinkHref="#calendar" />
                  </svg>
                </span>
                {date}
              </p>
              <h4
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  color: '#343a40',
                }}
              >
                {title}
              </h4>
              <p
                style={{
                  color: '#6c757d',
                  fontSize: '16px',
                  marginBottom: '20px',
                }}
              >
                {description}
              </p>
              <button
                type="button"
                className="btn btn-warning"
                style={{
                  display: 'inline-block',
                  padding: '10px 20px',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#fff',
                  backgroundColor: '#ffc107',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Publishing
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
